import { render, staticRenderFns } from "./AddColumnPopUp.vue?vue&type=template&id=55cbb726&scoped=true"
import script from "./AddColumnPopUp.vue?vue&type=script&lang=ts"
export * from "./AddColumnPopUp.vue?vue&type=script&lang=ts"
import style0 from "./AddColumnPopUp.vue?vue&type=style&index=0&id=55cbb726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cbb726",
  null
  
)

export default component.exports